export default __webpack_public_path__ + "static/media/app-token.ef732315.svg";